var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.companies.length > 1
        ? _c(
            "el-select",
            {
              staticClass: "mr-3",
              attrs: { placeholder: "選擇經銷商" },
              on: { change: _vm.onSelect },
              model: {
                value: _vm._id,
                callback: function ($$v) {
                  _vm._id = $$v
                },
                expression: "_id",
              },
            },
            _vm._l(_vm.companies, function (item) {
              return _c("el-option", {
                key: item.id,
                attrs: { label: item.name, value: item.id },
              })
            }),
            1
          )
        : _c("div", [_c("h3", [_vm._v(_vm._s(_vm.companies[0].name))])]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }